import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import FindFriendView from './FindFriendView';
import CouponView from './CouponView';
import tiaraClickSender from '../../utils/tiaraClickSender';

export class PortalPage extends Component {
  constructor(props) {
    super(props);
    this.handleOnClickTab = this.handleOnClickTab.bind(this);
    this.renderFindFriend = this.renderFindFriend.bind(this);
    this.renderCoupon = this.renderCoupon.bind(this);
    this.state = {
      tab: props.tabType === 'coupon' ? 'coupon' : 'friend',
      friendTabWheel: 0,
      couponTabWheel: 0
    }
  }

  handleOnClickTab(e, name) {
    if (e) {
      e.preventDefault()
    }
    if (this.state.tab !== name) {
      if (name === 'friend') {
        this.setState({ couponTabWheel: this.props.wheel });
      } else {
        this.setState({ friendTabWheel: this.props.wheel });
      }
    }
    this.setState({ tab: name })
  }
  
  renderFindFriend() {
    const { tabType } = this.props;
    return (
      <FindFriendView firstTab={tabType} scrollTop={this.state.friendTabWheel}/>
    );
  }

  renderCoupon() {
    const { tabType } = this.props;
    return (
      <CouponView firstTab={tabType} scrollTop={this.state.couponTabWheel}/>
    );
  }
    
  render() {
    const { location: { pathname }} = this.props;
    const { tab } = this.state;
    return (
      <div>
        <header id="kakaoHead">
          <h1 className="screen_out">카카오톡 채널</h1>
        </header>
        <hr className="hide" />
        <main id="kakaoContent">
          <article id="mArticle">
            <h2 className="screen_out">채널 메인 탭</h2>
            <ul className="tab_plus" role="tablist">
              <li className={ tab === 'friend' ? 'on' : '' } data-tiara-layer="friend">
                <a className="link_tab" role="tab" href="#friend"
                   onClick={(e) => { this.handleOnClickTab(e, 'friend'); }}
                   aria-selected={ tab === 'friend' ? 'true' : 'false' }
                   data-tiara-click_url={`${pathname}?type=friend`}>채널찾기</a>
              </li>
              <li className={ tab === 'coupon' ? 'on' : '' } data-tiara-layer="coupon">
                <a className="link_tab" role="tab" href="#coupon"
                   onClick={(e) => { this.handleOnClickTab(e, 'coupon'); }}
                   aria-selected={ tab === 'coupon' ? 'true' : 'false' }
                   data-tiara-click_url={`${pathname}?type=coupon`}>쿠폰</a>
              </li>
            </ul>
            {tab === 'friend' ? this.renderFindFriend() : this.renderCoupon()}
          </article>
        </main>
        <hr className="hide" />
        <footer className="foot_plus" id="kakaoFoot">
          <small className="ico_plus ico_copyright">
            카카오톡 채널
          </small>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = (state, {}) => {
  const { device, portal, wheel } = state;
  const tabType = portal.get('mainTabType') || 'friend';
  return { device, portal, tabType, wheel };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal,
  }, dispatch)
)(tiaraClickSender(PortalPage));


// WEBPACK FOOTER //
// ./src/containers/PortalPage/index.js